<button [ngClass]="[hierarchy, size]" type="button" [disabled]="disabled" (click)="handleClick()"
  [class.no-label]="label.length === 0">
  <img *ngIf="iconLeading" [src]="iconLeading" alt="{{'general.ICON' | transloco}}" />
  {{ label }}
  <img *ngIf="iconTrailing" [src]="iconTrailing" alt="{{'general.ICON' | transloco}}" />
  <div class="badge-container" *ngIf="badge">
    <div class="badge">
      <img [src]="badgeIcon" alt="{{'general.ALERT' | transloco}}" />
    </div>
  </div>
</button>